import { sbaAxios } from "../utils/sbaAxios";
import { gettransactionslist, getTransactionsMenulist } from "../../config/apiConfig";
import {
    FETCH_ASSETTRANSACTIONS_BEGIN,
    FETCH_ASSETTRANSACTIONS_SUCCESS,
    FETCH_ASSETTRANSACTIONS_FAILURE,
    FETCH_TRANSACTIONSMENULIST_BEGIN,
    FETCH_TRANSACTIONSMENULIST_SUCCESS,
    FETCH_TRANSACTIONSMENULIST_FAILURE
  } from '../constants/transactions';


export const getTransactionsList=(AssetId,FromDate,ToDate)=> {
  return (dispatch) => {
      dispatch(fetchTransactionListsBegin());
      sbaAxios({
          url: `${gettransactionslist}${AssetId},${FromDate},${ToDate}`,
          method: 'get',
      })
      .then((repos) => {
        const TransactionsList = repos;
        //Add logic to format the DataItem if needed using map
        dispatch(fetchTransactionListSuccess(TransactionsList));
        return TransactionsList;
      })
      .catch((error) => {return dispatch(fetchTransactionListFailure(error))});
  };
}

export const fetchTransactionListsBegin = () => ({
  type: FETCH_ASSETTRANSACTIONS_BEGIN,
});

export const fetchTransactionListSuccess = (transactionList) => ({
  type: FETCH_ASSETTRANSACTIONS_SUCCESS,
  payload: {transactionList},
});


export const fetchTransactionListFailure = (errorMessage) => ({
  type: FETCH_ASSETTRANSACTIONS_FAILURE,
  payload: {errorMessage}
});

export const getTransactionsMenuList=(Id)=>{
  return async (dispatch) => {
      dispatch(transactionsMenuListBegin());
        try {
            const response = await sbaAxios({
                url: `${getTransactionsMenulist}${Id}`,
                method: 'get',
            })
          const transactionMenuList = response;
          dispatch(transactionsMenuListSuccess(transactionMenuList));
        } catch (error) {
            dispatch(transactionsMenuListFailur(error));
        }
    };
} 

export const transactionsMenuListBegin = () => ({
  type: FETCH_TRANSACTIONSMENULIST_BEGIN,
  payload: {},
});

export const transactionsMenuListSuccess = (transactionMenuList) => ({
  type: FETCH_TRANSACTIONSMENULIST_SUCCESS,
  payload: {transactionMenuList},
});


export const transactionsMenuListFailur = (errorMessage) => ({
  type: FETCH_TRANSACTIONSMENULIST_FAILURE,
  payload: {errorMessage}
});

